import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { ProjectSummary } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiSummaryService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(): Observable<ProjectSummary[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/projectsummary`))
      .pipe(
        map((response: any, i) => {
          // console.log('fetch:map:response: ', response, i);
          // let returning =<Release[]>response; // response.map(r =>  Release.create((r)));
          // console.log('fetch:map:response: ', returning);
          return <ProjectSummary[]>response;
        }),
        map(r => r.map(x => ProjectSummary.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectSummaryService extends CasiSummaryService{

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('projectsummary', 'get');
  }

//   getById(id: number): Promise<any> {
//     return this.apiService.getHttpCallAsPromise(`release/${id}`, 'getById');
//   }

//   add(p: any): Promise<any> {
//     return this.apiService.postHttpCallAsPromise('release', p, 'add');
//   }

//   update(p: any): Promise<any> {
//     return this.apiService.putHttpCallAsPromise(`release/${p.id}`, p, 'update');
//   }

//   destroy(id: number): Promise<any> {
//     return this.apiService.deleteHttpCallAsPromise(`release/${id}`, 'destroy');
//   }

}
